export const productEditorEn = {
  subRefRequired: "This product code already exists. Enter a Sub Ref so the two can be told apart.",
  duplicateIdentity: "Another product already has this code and this Sub Ref. Sub Refs must differ.",
  subRefRequiredOnOther: "This product code already has a record with no Sub Ref. Give that record a Sub Ref first, then save this one.",
  descriptionRequired: "Enter a product description before saving.",
  typeRequired: "Select a product type before saving.",
  editTitle: "Edit product",
  duplicateTitle: "Create product variant",
  createHint: "Define the product and its specifications. Leave the code blank to assign the next number.",
  duplicateHint: "Variant of {{code}}. Specifications and supplier information are copied. Customer reference, approval proof and stock start fresh. Change the code or Sub Ref to identify the new variant.",
  changeVariant: "Change the code or Sub Ref so this variant differs from the source product.",
  codeRequired: "An existing product must keep a product code.",
  noPermission: "You do not have permission to create or edit this product.",
  dtdPrice: "DTD price (Door to Door)",
  exwPrice: "EXW price",
  underMoqPrice: "Under-MOQ price",
  stockReadOnly: "Usable stock from Kho & LOT; it changes only through warehouse documents.",
  legacyNegative: "Legacy negative values: {{fields}}. Unchanged values are preserved; enter a non-negative number or clear a field to correct it.",
  groups: {
    identity: "Identification", identityHint: "Item codes, classification and picture.",
    spec: "Description & specification", specHint: "Description printed on documents and labels, and the item's measurements.",
    sales: "Sales", salesHint: "List price, ordering terms and lead times.",
    purchasing: "Purchasing", purchasingHint: "Supplier and cost price — only people allowed to see cost see this group.",
    control: "Approval & stock", controlHint: "Sample approval, stock, default bin and remarks.",
    unitsHint: "Selling units converted to the base unit — edit them in Master data ▸ Units & price lists.",
  },
  more: {
    language: "Chinese description",
    wire: "Wire dimensions",
    material: "Material information",
    salesMore: "Other prices & quantities (floor price, DTD, EXW, under-MOQ, MCQ, MSQ)",
    controlMore: "Storage & mould",
  },
  moreFilled: "{{count}} filled",
  emptyMore: "Not filled: {{fields}}",
  groupNav: "Form sections",
  sellingPriceHint: "Default list price.",
  stockLink: "View stock by lot",
  defaultBin: "Default bin",
  defaultBinHint: "Pre-filled when receiving and putting away; actual locations are kept per lot.",
};

export const productEditorVi: typeof productEditorEn = {
  subRefRequired: "Mã sản phẩm này đã có bản khác. Hãy điền Sub Ref để phân biệt hai bản.",
  duplicateIdentity: "Đã có sản phẩm khác cùng mã và cùng Sub Ref. Sub Ref phải khác nhau.",
  subRefRequiredOnOther: "Mã sản phẩm này đã có một bản chưa điền Sub Ref. Hãy điền Sub Ref cho bản đó trước, rồi lưu bản này.",
  descriptionRequired: "Vui lòng nhập mô tả sản phẩm trước khi lưu.",
  typeRequired: "Vui lòng chọn loại sản phẩm trước khi lưu.",
  editTitle: "Sửa sản phẩm",
  duplicateTitle: "Tạo biến thể sản phẩm",
  createHint: "Nhập thông tin và quy cách sản phẩm. Để trống mã để hệ thống cấp số tiếp theo.",
  duplicateHint: "Biến thể của {{code}}. Đã sao chép quy cách và nhà cung cấp. Mã khách hàng, chứng từ duyệt và tồn kho được đặt lại. Đổi mã hoặc mã phụ để phân biệt biến thể mới.",
  changeVariant: "Đổi mã hoặc mã phụ để biến thể này khác sản phẩm gốc.",
  codeRequired: "Sản phẩm hiện có phải có mã sản phẩm.",
  noPermission: "Bạn không có quyền tạo hoặc sửa sản phẩm này.",
  dtdPrice: "Giá DTD (giao tận nơi)",
  exwPrice: "Giá EXW",
  underMoqPrice: "Giá dưới MOQ",
  stockReadOnly: "Tồn dùng được theo Kho & LOT; chỉ đổi qua chứng từ kho.",
  legacyNegative: "Giá trị âm từ dữ liệu cũ: {{fields}}. Giá trị chưa sửa được giữ nguyên; nhập số không âm hoặc xóa ô để sửa.",
  groups: {
    identity: "Nhận diện", identityHint: "Mã hàng, cách phân loại và ảnh.",
    spec: "Mô tả & quy cách", specHint: "Mô tả in lên chứng từ, tem và thông số của hàng.",
    sales: "Bán hàng", salesHint: "Giá niêm yết, điều kiện đặt hàng và thời gian giao.",
    purchasing: "Mua hàng", purchasingHint: "Nhà cung cấp và giá vốn — chỉ người được xem giá vốn thấy nhóm này.",
    control: "Duyệt & kho", controlHint: "Phê duyệt mẫu, tồn kho, kệ mặc định và ghi chú.",
    unitsHint: "Đơn vị bán quy đổi về đơn vị gốc — sửa ở Danh mục ▸ Đơn vị & bảng giá.",
  },
  more: {
    language: "Mô tả tiếng Hoa",
    wire: "Kích thước dây",
    material: "Thông tin vật liệu",
    salesMore: "Giá & số lượng khác (giá sàn, DTD, EXW, dưới MOQ, MCQ, MSQ)",
    controlMore: "Kho chứa & khuôn",
  },
  moreFilled: "{{count}} ô có dữ liệu",
  emptyMore: "Chưa điền: {{fields}}",
  groupNav: "Các nhóm của biểu mẫu",
  sellingPriceHint: "Giá niêm yết mặc định.",
  stockLink: "Xem tồn theo lô",
  defaultBin: "Kệ mặc định",
  defaultBinHint: "Điền sẵn khi nhận và cất hàng; vị trí thật ghi theo từng lô.",
};

export const productEditorZh: typeof productEditorEn = {
  subRefRequired: "此产品编号已有其他记录，请填写子参考以区分两者。",
  duplicateIdentity: "已有其他产品使用相同编号与相同子参考。子参考必须不同。",
  subRefRequiredOnOther: "此产品编号已有一条未填子参考的记录。请先为该记录填写子参考，再保存本条。",
  descriptionRequired: "保存前请输入产品描述。",
  typeRequired: "保存前请选择产品类型。",
  editTitle: "编辑产品",
  duplicateTitle: "创建产品变体",
  createHint: "填写产品资料与规格。产品编号留空即可自动分配下一个号码。",
  duplicateHint: "{{code}} 的变体。已复制规格与供应商信息；客户参考编号、批准证明及库存已重置。请更改产品编号或子参考以识别新变体。",
  changeVariant: "请更改产品编号或子参考，使此变体与来源产品不同。",
  codeRequired: "现有产品必须保留产品编号。",
  noPermission: "您没有创建或编辑此产品的权限。",
  dtdPrice: "DTD 价格（门到门）",
  exwPrice: "EXW 价格",
  underMoqPrice: "低于 MOQ 价格",
  stockReadOnly: "“仓库与批次”的可用库存，只通过仓库单据变动。",
  legacyNegative: "旧数据的负值：{{fields}}。未修改的值会保留；请输入非负数或清空字段以修正。",
  groups: {
    identity: "基本信息", identityHint: "品号、分类与图片。",
    spec: "描述与规格", specHint: "打印于单据与标签上的描述，以及货品规格。",
    sales: "销售", salesHint: "标价、订购条件与交期。",
    purchasing: "采购", purchasingHint: "供应商与成本价——仅有权查看成本者可见。",
    control: "审核与库存", controlHint: "样品审核、库存、默认库位与备注。",
    unitsHint: "销售单位换算为基本单位——于“主数据 ▸ 单位与价目表”修改。",
  },
  more: {
    language: "中文描述",
    wire: "线材尺寸",
    material: "材料信息",
    salesMore: "其他价格与数量（底价、DTD、EXW、低于 MOQ、MCQ、MSQ）",
    controlMore: "存放与模具",
  },
  moreFilled: "已填 {{count}} 项",
  emptyMore: "未填：{{fields}}",
  groupNav: "表单分组",
  sellingPriceHint: "默认标价。",
  stockLink: "查看各批次库存",
  defaultBin: "默认库位",
  defaultBinHint: "收货及上架时预先带入；实际库位以各批次为准。",
};
